/* eslint-disable react/require-default-props */
import 'moment/locale/ja';
import ReactDatePicker from 'react-datetime';
import { Control, Controller, FieldValues, Path, UnPackAsyncDefaultValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props<T extends FieldValues> {
  id?: string | undefined;
  name: Path<UnPackAsyncDefaultValues<T>>;
  isDisabled: boolean;
  control: Control<T>;
  displayMark: boolean;
}

/**
 * react-datetime の DatePicker を 本システム用にスタイル付けしたもの
 * @param
 * @returns
 */
function DatePicker<T extends FieldValues>({ id, name, isDisabled, control, displayMark }: Props<T>) {
  // 言語情報
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <span className="calendar">
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <ReactDatePicker
            locale={language}
            onChange={(date) => {
              if (typeof date !== 'string') {
                // date は 日付だけでなく、時間まで含まれているので、string 型に変換して、form コントロールに渡す
                field.onChange(date.format('YYYY-MM-DD'));
              } else {
                field.onChange(date);
              }
            }}
            inputProps={{ disabled: isDisabled, className: 'datepicker', id }}
            renderInput={(props, openCalendar) => (
              <>
                <input {...props} value={typeof field.value === 'string' ? (field.value as string).replaceAll('-', '/') : ''} autoComplete="off"/>
                {displayMark && (
                  <i
                    className="fa-solid fa-calendar-days"
                    onClick={() => {
                      if (!isDisabled) {
                        openCalendar();
                      }
                    }}
                  />
                )}
              </>
            )}
            // 日付は yyyy/MM/dd 形式で表示。サーバー側への送信は yyyy-MM-dd 形式
            value={typeof field.value === 'string' ? (field.value as string).replaceAll('-', '/') : undefined}
            className={displayMark ? undefined : 'no-mark-calendar'}
            dateFormat="YYYY/MM/DD"
            timeFormat={false}
            closeOnSelect
          />
        )}
      />
    </span>
  );
}

DatePicker.defaultProps = {
  id: undefined,
};

export default DatePicker;
